import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ObjectHistory } from '@iotv/datamodel-core';
import { Button, Stack, Switch, Typography } from '@mui/material';
import React from 'react';
import { ActionIcons } from '../../../Iconography';
import { ConsumerDao } from '../../../data/ConsumerDAO';
export const ObjectHistoryControls = ({ objectHistory, setObjectHistory }) => {
    const handleDeleteObjectHistory = async () => {
        if (objectHistory) {
            const oh = new ObjectHistory(objectHistory);
            delete oh.recentStateHistory;
            delete oh.dailyStateHistory;
            delete oh.weeklyStateHistory;
            delete oh.monthlyStateHistory;
            delete oh.yearlyStateHistory;
            const { err, data } = await ConsumerDao.saveObjectHistory({ sk: objectHistory.sk, objectHistory: oh });
            if (data) {
                setObjectHistory(undefined);
            }
            if (err) {
                console.log(`WARN: failed to delete objectHistory`, err.message);
            }
        }
        else {
            console.log(`WARN: handleDeleteObjectHistory no objectHistory`);
        }
    };
    const [locked, setLocked] = React.useState(true);
    return (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [_jsx(Switch, { checked: !locked, onChange: () => setLocked(!locked) }), _jsx(Button, { variant: "outlined", disabled: locked, endIcon: _jsx(ActionIcons.Delete, {}), onClick: handleDeleteObjectHistory, children: "Remove" }), _jsx(Typography, { color: "warning", display: locked ? 'none' : undefined, children: "This will delete this object history and the system will begin a new one!" })] }));
};
